module.exports = __webpack_public_path__ + "static/media/lucas_martinez_quarta.1dfe9a42.jpg";